import { ApprovalDetailsDialogConfig } from './approval-details-dialog.component';
import { APPROVAL_DETAILS_TABLE_COLUMNS } from '../../../synchronization.config';

export const APPROVAL_DETAILS_CONFIG: ApprovalDetailsDialogConfig = {
  title: 'synchronization.dialog.approval_details.title',
  width: 'auto',
  maxWidth: '95vw',
  height: 'auto',
  maxHeight: '85vh',
  tableColumns: APPROVAL_DETAILS_TABLE_COLUMNS
};
